// File: cgp-authentication.js
// Author: Brandon Shreve
// Date: 1/9/2017
// Desc: Authentication module that handles integrating with CGP Authentication.
//       Handles redirecting to GAME login page and reading the cookie that has our authorization token.
//       Has methods to get the authorization token as well as the logged in user's information.
// Other Contributors: Joseph M Diaz

import { config } from '../config/config';
import { cgpCookieHelper } from './cgp-cookie-helper';
import { cgpSecurityUrls, cgpLoginUrls } from '../../src/config/config.base';
import { ENV } from './utility';

function updateLoading(msg, token = '') {
    const x = document.getElementById('loading');

    const user = getUserInfo();

    if (!token || !user) return;
    x.firstElementChild.firstElementChild.lastElementChild.lastElementChild.innerHTML = user.cn;
    x.firstElementChild.className = 'user';
    x.lastElementChild.innerHTML = msg;
}

function updateMescLoading(msg){
    var x = document.getElementById('loading');
    x.lastElementChild.innerHTML = msg;
}

function singleSignOnRedirect(redirectLink: Location) {
    const env = ENV.value;
    const cgpSecurityUrl = cgpLoginUrls[env] + redirectLink;
    window.location.replace(cgpSecurityUrl);
    updateLoading('Logging in...');
}

function validateToken(callback: Function) {
    const token = getAuthToken();
    updateLoading('Validating Token...', token);
    if (token) {
        const env = ENV.value;
        const url = cgpSecurityUrls[env] + 'validateToken';
        const http = new XMLHttpRequest();

        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/json');
        http.setRequestHeader('Authorization', token);
        http.onreadystatechange = function () {
            if (http.readyState !== XMLHttpRequest.DONE) {
                return;
            }

            if (http.status === 200) {
                const newToken = http.getResponseHeader(config.authentication.authenticationCookie);
                cgpCookieHelper.setAuthCookie(newToken.replace(/^\s*Bearer\s*/, ''));
                if (callback) { callback(); }
            }
            else {
                singleSignOnRedirect(document.location);
            }
        };
        http.send();
    }
    else {
        singleSignOnRedirect(document.location);
    }
}

function refreshToken(callback: Function) {
    const token = getAuthToken();
    const env = ENV.value;
    const url = cgpSecurityUrls[env] + 'refreshToken';
    const http = new XMLHttpRequest();

    http.open('POST', url, true);
    http.setRequestHeader('Content-type', 'application/json');
    http.setRequestHeader('Authorization', token);

    http.onreadystatechange = function () {
        if (http.readyState !== XMLHttpRequest.DONE) {
            return;
        }

        if (http.status === 200) {
            const newToken = http.getResponseHeader(config.authentication.authenticationCookie);
            cgpCookieHelper.setAuthCookie(newToken.replace(/^\s*:\s*Bearer\s*/, ""));
            if (callback) { callback(null, 'success'); }
        }
        else {
            if (callback) { callback('error', null); }
        }
    };
    http.send();
}

function invalidateToken(callback: Function) {

    cgpCookieHelper.deleteAuthCookie();
}

function parseToken(token) {
    return token ? token.replace('Bearer_', 'Bearer ') : '';
}

function getAuthToken() {
    const token = cgpCookieHelper.retrieveCookie(config.authentication.authenticationCookie);
    return parseToken(token);
}

function getUserInfo() {
    const userInfo = cgpCookieHelper.retrieveCookie(config.authentication.userInfoCookie);

    try {
        if (userInfo) {
            const userInfoFilter = userInfo
                .replace(/\[\\\\\\\"/g, '')
                .replace(/\\\\\\\"\]/g, '');
            return JSON.parse(JSON.parse(userInfoFilter));
        }

        return null;
    } catch (e) {
        return {
            cn: 'Mock User',
            gmuniqueidentifier: '404536778'
        }
    }
}

export const cgpAuthentication = {
    singleSignOnRedirect,
    getAuthToken,
    getUserInfo,
    validateToken,
    invalidateToken,
    refreshToken,
    updateMescLoading,
}
